import { isFeatureEnabled } from 'owa-feature-flags';
import isBusiness from 'owa-session-store/lib/utils/isBusiness';

export function isSonoraPluginMeetingTimeSuggestionsEnabled(): boolean {
    return isFeatureEnabled('honeybee-sonora-meetingTime') && isBusiness();
}

export function isSonoraMentionsPluginMeetingTimeSuggestionsEnabled(): boolean {
    return isFeatureEnabled('honeybee-sonora-mentions-meetingTime') && isBusiness();
}
